<template>
  <div class="electricity px">
    <div class="item" v-if="showBattery">
      <div class="battery-info-container">
        <div class="device-name">
          {{ $t("mouse.name") }}
        </div>
        <div
          class="battery-logo-container"
          :class="{ charging: mouseChargingStatus === 1 }"
        >
          <div class="battery-disabled-line" v-if="mouseExits === 0"></div>
          <template v-if="mouseExits !== 0">
            <div
              class="battery-percent-stroke"
              v-for="i in mouseNum"
              :key="i"
            ></div>
          </template>
        </div>
        <div class="battery-inner-container">
          <div class="battery-number">
            <span v-if="mouseExits !== 0">{{ formattedBattery }}</span>
          </div>
          <template
            v-if="dongleChargingStatus === 1 || mouseChargingStatus === 1"
          >
            <i
              class="iconfont icondian"
              style="
                font-size: 12px;
                visibility: visible;
                transform: translateY(-1px);
              "
              v-if="mouseChargingStatus === 1"
            />
            <i
              class="iconfont icondian"
              style="
                font-size: 12px;
                visibility: hidden;
                transform: translateY(-1px);
              "
              v-else
            />
          </template>
        </div>
      </div>
    </div>
    <div class="item" v-if="showDongle">
      <div class="battery-info-container">
        <div class="device-name">
          Dongle
        </div>
        <div
          class="battery-logo-container"
          :class="{ charging: dongleChargingStatus === 1 }"
        >
          <div class="battery-disabled-line" v-if="dongleExits === 0"></div>
          <template v-if="dongleExits !== 0">
            <div
              class="battery-percent-stroke"
              v-for="i in mouseDNum"
              :key="i"
            ></div>
          </template>
        </div>
        <div class="battery-inner-container">
          <div class="battery-number">
            <span v-if="dongleExits !== 0">{{ formatDongleBattery }}</span>
          </div>
          <template
            v-if="dongleChargingStatus === 1 || mouseChargingStatus === 1"
          >
            <i
              class="iconfont icondian"
              style="
                font-size: 12px;
                visibility: visible;
                transform: translateY(-1px);
              "
              v-if="dongleChargingStatus === 1"
            />
            <i
              class="iconfont icondian"
              style="
                font-size: 12px;
                visibility: hidden;
                transform: translateY(-1px);
              "
              v-else
            />
          </template>
        </div>
      </div>
    </div>
    <c-mouse-am35-battery-popover
      :sn="sn"
      :mouseHealthValue="mouseHealth"
      :mouseExits="mouseExits"
      :dongleHealthValue="dongleHealth"
      :dongleExits="dongleExits"
      placement="bottomRight"
      trigger="click"
    >
      <div class="item" v-if="showLab">
        <div class="lab">
          AM LAB
        </div>
      </div>
    </c-mouse-am35-battery-popover>
  </div>
</template>
<script>
import { Modal } from "ant-design-vue";
import {
  calculateBatteryBars,
  formatBatteryDisplay,
} from "../utils/batteryUtils";
import { deviceCallbackManager } from "@/utils/DeviceCallbackManager";

const BATTERY_POLL_INTERVAL = 5 * 1000;
const BATTERY_OFFLINE_RECOVERY_INTERVAL = 1 * 1000;
const BATTERY_OFFLINE_RETRY_THRESHOLD = 3;

export default {
  name: "CMouseAm35Electricity",
  props: {
    showBattery: {
      type: Boolean,
      default: true,
    },
    showDongle: {
      type: Boolean,
      default: false,
    },
    showLab: {
      type: Boolean,
      default: false,
    },
    sn: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      mouseBattery: 100, // 鼠标电量 范围:0-100
      mouseHealth: 100, // 电池健康度 范围:0-100
      mouseExits: 1, // 是否存在鼠标电池 1有 0无
      dongleBattery: 0, // 鼠标dongle电量 范围:0-100
      dongleHealth: 100, // 电池dongle健康度 范围:0-100
      dongleExits: 0, // 是否存在dongle电池 1有 0无
      mouseChargingStatus: 0, // 鼠标充电状态 范围:0不充电 1充电中 2充满
      dongleChargingStatus: 0, // dongle充电状态 范围: 0不充电 1充电中 2充满
      timer: 0,
      offlineRecoveryTimer: 0,
      isInitialized: false, // AM35数据是否已初始化
      offlineHandled: false,
      offlineFailureCount: 0,
      offlineModalRef: null,
      // 非空表示当前有流程暂时接管设备状态，此时暂停电量轮询和离线弹窗。
      // 当前实际来源：
      // - Mouse.vue: reset / export / import / switchProfile
      // - Firmware.vue: firmwarePassword / firmwareUpdate
      // 形态示例：{ import: true, firmwareUpdate: true, firmwarePassword: true }
      pausedGuardSources: Object.create(null),
    };
  },
  computed: {
    mouseNum() {
      return calculateBatteryBars(this.mouseBattery);
    },
    mouseDNum() {
      return calculateBatteryBars(this.dongleBattery);
    },
    formattedBattery() {
      return formatBatteryDisplay(this.mouseBattery, true);
    },
    formatDongleBattery() {
      return formatBatteryDisplay(this.dongleBattery, true);
    },
  },
  mounted() {
    // 通过 DeviceCallbackManager 订阅电量事件
    deviceCallbackManager.subscribe(
      "updatetAM35Battery",
      this.onHostUpdateAM35Battery
    );

    // showLab 模式（Firmware 页面）：直接开始获取电量，不等待 initAM35Data
    if (this.showLab) {
      this.onInitComplete();
    } else {
      // 订阅初始化完成事件
      deviceCallbackManager.subscribe("initAM35Data", this.onInitComplete);
    }
  },
  beforeDestroy() {
    // 组件销毁时清除定时器，避免退出页面后继续发送获取电量指令
    this.clearPollTimer();
    this.clearOfflineRecoveryTimer();
    this.closeOfflineModal();
    // 取消 DeviceCallbackManager 订阅
    deviceCallbackManager.unsubscribe &&
      deviceCallbackManager.unsubscribe("initAM35Data", this.onInitComplete);
    deviceCallbackManager.unsubscribe &&
      deviceCallbackManager.unsubscribe(
        "updatetAM35Battery",
        this.onHostUpdateAM35Battery
      );
  },
  methods: {
    // 只要还有任意一个来源没恢复，就认为电量守卫仍处于暂停状态。
    isBatteryGuardPaused() {
      return Object.keys(this.pausedGuardSources).length > 0;
    },
    // Firmware 的 showLab 以及主动暂停场景，都不应该触发离线弹窗接管。
    shouldIgnoreBatteryOffline() {
      return this.showLab || this.isBatteryGuardPaused();
    },
    // 某个业务流程开始时调用：
    // 1. 记录是谁要求暂停
    // 2. 停掉轮询，避免流程中途被电量逻辑打断
    pauseBatteryGuard(source = "default") {
      if (this.pausedGuardSources[source]) {
        return;
      }
      this.$set(this.pausedGuardSources, source, true);
      this.clearPollTimer();
    },
    // 某个业务流程结束时调用：
    // 1. 删除自己的暂停标记
    // 2. 只有当“所有暂停来源都已清空”时，才允许真正恢复电量守卫
    // 3. refresh=true 表示恢复后立即补发一次电量请求
    resumeBatteryGuard(
      source = "default",
      { refresh = false, force = false } = {}
    ) {
      if (this.pausedGuardSources[source]) {
        this.$delete(this.pausedGuardSources, source);
      }
      if (!refresh || this.isBatteryGuardPaused() || this.offlineHandled) {
        return;
      }
      this.requestBattery({ force });
    },
    clearPollTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    clearOfflineRecoveryTimer() {
      if (this.offlineRecoveryTimer) {
        clearTimeout(this.offlineRecoveryTimer);
        this.offlineRecoveryTimer = null;
      }
    },
    closeOfflineModal() {
      if (this.offlineModalRef?.destroy) {
        this.offlineModalRef.destroy();
        this.offlineModalRef = null;
      }
    },
    scheduleOfflineRecoveryPoll() {
      this.clearOfflineRecoveryTimer();
      if (!this.offlineHandled || this.shouldIgnoreBatteryOffline()) {
        return;
      }
      // 鼠标休眠时会上报一包 N/A 离线数据。
      // 这类情况允许在弹窗期间低频补发 getAM35Battery，直到收到正常电量包为止。
      this.offlineRecoveryTimer = setTimeout(() => {
        if (!this.offlineHandled || this.shouldIgnoreBatteryOffline()) {
          this.clearOfflineRecoveryTimer();
          return;
        }
        this.$store.dispatch("loader/getAM35Battery");
        this.scheduleOfflineRecoveryPoll();
      }, BATTERY_OFFLINE_RECOVERY_INTERVAL);
    },
    handleOnlineRecovered() {
      this.offlineHandled = false;
      this.offlineFailureCount = 0;
      this.clearOfflineRecoveryTimer();
      this.closeOfflineModal();
    },
    handleOfflineFailure() {
      if (this.shouldIgnoreBatteryOffline()) {
        this.offlineFailureCount = 0;
        return false;
      }
      this.offlineFailureCount += 1;
      return this.offlineFailureCount >= BATTERY_OFFLINE_RETRY_THRESHOLD;
    },
    handleOffline() {
      // 已弹过离线窗，或当前本来就是允许“静默失败”的阶段，都直接跳过。
      if (this.offlineHandled || this.shouldIgnoreBatteryOffline()) {
        return;
      }
      this.offlineHandled = true;
      this.clearPollTimer();
      this.clearOfflineRecoveryTimer();
      Modal.destroyAll();
      this.offlineModalRef = this.$info({
        title: this.$t("mouse.offline"),
        okText: this.$t("yes"),
        centered: true,
        onOk: () => {
          this.clearOfflineRecoveryTimer();
          this.offlineModalRef = null;
          this.$store.dispatch("loader/setLoading", false);
          this.$router.replace(this.$paths.deviceList);
        },
      });
      this.scheduleOfflineRecoveryPoll();
    },
    requestBattery({ force = false } = {}) {
      // 守卫暂停期间，不再下发新的获取电量请求。
      if (this.isBatteryGuardPaused()) {
        this.clearPollTimer();
        return;
      }
      if ((!this.isInitialized && !force) || this.offlineHandled) {
        return;
      }
      this.clearPollTimer();
      this.$store.dispatch("loader/getAM35Battery");
    },
    // 初始化完成回调
    onInitComplete() {
      console.log("Electricity: AM35 初始化完成，开始获取电量");
      this.isInitialized = true;
      // 初始化完成后，立即获取电量
      this.requestBattery();
    },
    isErrorConnectedPayload(data) {
      return (
        data?.mouseChargingStatus === 0 &&
        data?.mouseBattery === 0 &&
        data?.mouseHealth === 0 &&
        data?.mouseExits === 0 &&
        data?.dongleChargingStatus === "N/A" &&
        data?.dongleBattery === "N/A" &&
        data?.dongleHealth === "N/A" &&
        data?.dongleExits === "N/A"
      );
    },
    applyBatteryData(data) {
      this.mouseBattery = data?.mouseBattery ?? 0;
      this.mouseHealth = data?.mouseHealth ?? 0;
      this.mouseExits = data?.mouseExits ?? 0;
      this.dongleBattery = data?.dongleBattery ?? 0;
      this.dongleHealth = data?.dongleHealth ?? 0;
      this.dongleExits = data?.dongleExits ?? 0;
      this.mouseChargingStatus = data?.mouseChargingStatus ?? 0;
      this.dongleChargingStatus = data?.dongleChargingStatus ?? 0;
    },
    scheduleNextBatteryPoll() {
      if (this.isInitialized && !this.isBatteryGuardPaused()) {
        // 连续收到多包正常电量时，只保留最后一次常规轮询，避免 timer 叠加。
        this.clearPollTimer();
        this.timer = setTimeout(() => {
          this.requestBattery();
        }, BATTERY_POLL_INTERVAL);
      }
    },
    onHostUpdateAM35Battery(json) {
      if (json) {
        console.log("updatetAM35Battery", json);
        const data = JSON.parse(json);
        if (!data) {
          return;
        }
        const isErrorConnected = this.isErrorConnectedPayload(data);

        if (isErrorConnected) {
          // 某些关键流程里设备短时返回异常值是允许的，此时不弹离线窗。
          if (this.shouldIgnoreBatteryOffline()) {
            this.offlineFailureCount = 0;
            this.clearPollTimer();
            return;
          }
          // 连续三次异常后，才接管为离线，避免偶发单包失败立刻弹窗。
          if (this.handleOfflineFailure()) {
            this.handleOffline();
          } else {
            this.scheduleNextBatteryPoll();
          }
          return;
        }
        this.offlineFailureCount = 0;
        if (this.offlineHandled) {
          // 只有 N/A 离线弹窗，收到正常包后才自动关闭弹窗并恢复常规轮询。
          this.handleOnlineRecovered();
        }
        this.applyBatteryData(data);
        this.scheduleNextBatteryPoll();
        console.log("updatetAM35Battery", "true");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../styles/battery.scss";
.electricity.px {
  font-size: 16px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  z-index: 2;
  top: 20px;
  right: 20px;

  .item {
    @include flex-center;
    width: 140px; /* 恢复宽度设置 */
    justify-content: flex-end;
    margin-bottom: 5px;
    flex-wrap: nowrap; /* 防止元素折行 */

    .device-name {
      width: 100%; /* 恢复宽度设置，确保文字保持水平 */
      text-align: right;
      font-size: 14px;
      color: #ffffff;
      margin-right: 0.08rem; /* 保持与其他元素的间距一致 */
      white-space: nowrap; /* 防止文字折行 */
    }
    .lab {
      color: $primary-color;
      font-size: 28px;
    }

    .battery-info-container {
      @include flex-center;
      width: 140px;
      justify-content: flex-end;
      position: relative;
      align-items: center; /* 确保子元素垂直居中对齐 */
      --element-spacing: 0.08rem; /* 使用CSS变量统一定义元素间距 */
      gap: var(--element-spacing); /* 设置元素间距 */
      flex-wrap: nowrap; /* 防止元素折行 */
      flex-direction: row; /* 明确指定水平方向排列 */

      /* 使用共享样式类 */
      .battery-logo-container {
        /* 共享样式已包含大部分定义，这里只保留特定的覆盖 */
        margin: 0; /* 清除可能的边距，由容器的gap控制间距 */
        margin-right: 0.04rem;
        &.charging .percentage:last-child {
          animation: chargingChange 2s infinite linear;
        }
      }
    }
  }
}
/* 使用共享样式中的动画 */
</style>
